import styles from './ua.module.scss'

export default function ButtonBadge(props) {

  return <span className={(props.children ? styles['badge-text'] : styles['badge']) + ' ' + styles[props.theme]}>
    { props.children }
  </span>
  
}